import React, { useState } from 'react';
import { ToastProvider } from '../utils/Toast.jsx';
import GeneralSettingsTab    from '../components/Tabs/generalSettingsTab.js';
import TranslationSettingsTab from '../components/Tabs/translationSettingsTab.js';
import StyleSettingsTab       from '../components/Tabs/styleSettingsTab.js';
import DonationReportTab      from '../components/Tabs/donationReportTab.js';

const TABS = [
  { name: 'general',        label: 'General',         desc: 'Core plugin options'   },
  { name: 'translations',   label: 'Translations',    desc: 'Language & locale'     },
  { name: 'styles',         label: 'Styles',          desc: 'Visual customisation'  },
  { name: 'donationReport', label: 'Donation Report', desc: 'Analytics & exports'   },
];

const HEADER_LINKS = [
  { href: 'https://www.plugin999.com/support/', label: 'Support', variant: 'outline' },
  { href: 'https://wordpress.org/support/plugin/build-private-store-for-woocommerce/reviews/', label: 'Rate Plugin', variant: 'star' },
  { href: 'https://www.plugin999.com/plugin/build-private-store-for-woocommerce/', label: 'Go Pro', variant: 'pro' },
];

function renderTabContent(name) {
  switch (name) {
    case 'translations':   return <TranslationSettingsTab />;
    case 'styles':         return <StyleSettingsTab />;
    case 'donationReport': return <DonationReportTab />;
    default:               return <GeneralSettingsTab />;
  }
}

const BackendApp = () => {
  const [activeTab, setActiveTab] = useState('general');

  const activeTabMeta = TABS.find(t => t.name === activeTab);

  return (
    <ToastProvider>
      <div className="dotfw-root">

        {/* ── Top header bar ── */}
        <header className="dotfw-topbar">
          <div className="dotfw-topbar-brand">
            <div className="dotfw-topbar-title-group">
              <h1 className="dotfw-topbar-title">Donation or Tip For WooCommerce</h1>
              <span className="dotfw-topbar-sub">Enable donations and tips directly in your WooCommerce store</span>
            </div>
          </div>

          <nav className="dotfw-topbar-actions" aria-label="Plugin links">
            {HEADER_LINKS.map(({ href, label, variant }) => (
              <a
                key={variant}
                href={href}
                style={{ marginRight: '10px', fontSize: '16px', color: '#606781' }}
                target="_blank"
                rel="noreferrer"
              >
                {label}
              </a>
            ))}
          </nav>
        </header>

        {/* ── Body: sidebar + content ── */}
        <div className="dotfw-body">

          {/* ── Sidebar ── */}
          <aside className="dotfw-sidebar" aria-label="Settings navigation">
            <p className="dotfw-sidebar-heading">Settings</p>
            <nav className="dotfw-sidebar-nav">
              {TABS.map((tab) => (
                <button
                  key={tab.name}
                  className={`dotfw-sidebar-item ${activeTab === tab.name ? 'is-active' : ''}`}
                  onClick={() => setActiveTab(tab.name)}
                  aria-current={activeTab === tab.name ? 'page' : undefined}
                >
                  <span className="dotfw-sidebar-item-text">
                    <span className="dotfw-sidebar-item-label">{tab.label}</span>
                    <span className="dotfw-sidebar-item-desc">{tab.desc}</span>
                  </span>
                  {activeTab === tab.name && (
                    <span className="dotfw-sidebar-item-indicator" aria-hidden="true" />
                  )}
                </button>
              ))}
            </nav>
          </aside>

          {/* ── Main content ── */}
          <main className="dotfw-content" id="dotfw-tab-panel">
            <div className="dotfw-content-body">
              {renderTabContent(activeTab)}
            </div>
          </main>

        </div>
      </div>
    </ToastProvider>
  );
};

export default BackendApp;